<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <!-- 搜索条件表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px">
          <!-- 第一行搜索条件 -->
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="员工姓名">
                <el-select v-model="queryParams.employeePid" placeholder="请选择员工" clearable filterable style="width: 100%;" :loading="employeeLoading" @change="handleQuery">
                  <el-option v-for="item in employeeList" :key="item.employeePid" :label="item.employeeName" :value="item.employeePid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="年月">
                <el-date-picker v-model="queryParams.yearMonth" type="month" placeholder="请选择年月" format="yyyy-MM" value-format="yyyy-MM" style="width: 100%;" :clearable="false"
                                @change="handleQuery"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="确认状态">
                <el-select v-model="queryParams.confirmationStatus" placeholder="请选择确认状态" style="width: 100%;" @change="handleQuery">
                  <el-option label="待确认" value="0"></el-option>
                  <el-option label="已确认" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 操作按钮 - 使用权限按钮组件 -->
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" :disabledButtons="confirmDisabledButtons" @handleQuery="handleQuery" @handleApply="handleConfirm" />
          </div>

          <!-- 数据表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" height="500" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="left" :index="indexMethod"></el-table-column>
            <el-table-column label="员工" align="left" prop="employeeName" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测年月" align="left" prop="inspectionYearMonth" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测台数" align="left" prop="inspectionCount" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测说明" align="left" min-width="260" show-overflow-tooltip>
              <template slot-scope="scope">
                扶梯台数：{{ scope.row.escalatorCount }} 直梯(≤10层)台数：{{ scope.row.elevatorLte10Count }} 直梯(>10层)台数：{{ scope.row.elevatorGt10Count }}
              </template>
            </el-table-column>
            <el-table-column label="提成单价" align="left" prop="commissionUnitPrice" min-width="180" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.commissionUnitPrice || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="提成金额" align="right" prop="totalCommission" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatMoney(scope.row.totalCommission) }}
              </template>
            </el-table-column>
            <el-table-column label="确认状态" align="left" prop="confirmationStatus" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :type="scope.row.confirmationStatus === '1' || scope.row.confirmationStatus === 1 ? 'success' : 'warning'">
                  {{ scope.row.confirmationStatus === '1' || scope.row.confirmationStatus === 1 ? '已确认' : '待确认' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="150" fixed="right">
              <template slot-scope="scope">
                <!-- 使用权限按钮组件 -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleDetail(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入详情弹出层组件 -->
    <DetailDialog ref="detailDialog" />
  </div>
</template>

<script>
import DetailDialog from './DetailDialog.vue';
import { queryPerformanceList, confirmPerformance, queryEmployee } from '@/api/contract/contract';

export default {
  name: 'PerformanceManagement',
  components: {
    DetailDialog
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    // 获取当前年月，格式：YYYY-MM
    const now = new Date();
    const currentYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

    return {
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 选中的行数据
      selectedRows: [],
      // 员工列表
      employeeList: [],
      employeeLoading: false,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        employeePid: undefined, // 员工ID
        yearMonth: currentYearMonth, // 年月，默认本年本月
        confirmationStatus: '0' // 确认状态，默认0-待确认
      }
    };
  },
  computed: {
    // 确认按钮禁用状态
    confirmDisabledButtons () {
      return this.selectedRows.length === 0 ? ['handleApply'] : [];
    }
  },
  created () {
    this.getEmployeeList();
    this.getList();
  },
  activated () {
    // 如果该页面被 keep-alive 缓存，返回页面时 created 不会再次触发，这里补一次刷新
    this.getList();
  },
  methods: {
    /**
     * 计算序号（考虑分页）
     */
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },

    /**
     * 格式化金额
     */
    formatMoney (value) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }
      return Number(value).toFixed(2);
    },

    /**
     * 获取员工列表
     */
    getEmployeeList () {
      this.employeeLoading = true;
      const params = {
        pageSize: 200,
        curPage: 1
      };

      queryEmployee(params)
        .then(res => {
          if (res.dataList) {
            this.employeeList = res.dataList || [];
          } else {
            this.$message.error(res.retMsg || '获取员工列表失败');
            this.employeeList = [];
          }
          this.employeeLoading = false;
        })
        .catch(err => {
          this.$message.error('获取员工列表失败：' + (err.message || '网络错误'));
          this.employeeList = [];
          this.employeeLoading = false;
        });
    },

    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true;

      // 调用查询绩效列表的API
      queryPerformanceList(this.queryParams).then(res => {
        // 根据后端返回格式解析：
        // additionalData: {
        //   curPage, pageSize, totalRowNum, dataList: [...]
        // }
        let records = []
        let current = this.queryParams.currPage
        let size = this.queryParams.pageSize
        let total = 0

        if (res && res.additionalData && Array.isArray(res.additionalData.dataList)) {
          const page = res.additionalData
          records = page.dataList
          current = page.curPage || current
          size = page.pageSize || size
          total = page.totalRowNum || records.length
        } else if (Array.isArray(res)) {
          records = res
          total = res.length
        } else if (res && Array.isArray(res.additionalData)) {
          records = res.additionalData
          total = records.length
        } else if (res && res.retCode !== undefined) {
          // 有标准返回结构，但没有数据
          this.$message.error(res.retMsg || '获取绩效列表失败')
        } else {
          // 无法识别的返回结构
          this.$message.error('获取绩效列表失败：返回数据格式不正确')
        }

        this.tableData = records
        this.queryParams.currPage = current
        this.queryParams.pageSize = size
        this.total = total
        this.loading = false
      }).catch(error => {
        console.error('获取绩效列表失败:', error);
        this.loading = false;
        this.$message.error('获取绩效列表失败');
      });
    },

    /**
     * 查询按钮
     */
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },

    /**
     * 确认按钮 - 批量确认
     */
    handleConfirm () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请先选择要确认的数据');
        return;
      }

      // 检查是否都是待确认状态
      const hasConfirmed = this.selectedRows.some(row => {
        return row.confirmationStatus === '1' || row.confirmationStatus === 1;
      });

      if (hasConfirmed) {
        this.$message.warning('选中的数据中包含已确认的记录，请重新选择');
        return;
      }

      this.$confirm('确定要确认选中的绩效记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 获取当前登录账号的名称
        const confirmedBy = (this.$store && this.$store.state && this.$store.state.loginUser && this.$store.state.loginUser.userName) ? this.$store.state.loginUser.userName : '';

        // 提取员工ID数组
        const employeePids = this.selectedRows.map(row => row.employeePid).filter(Boolean);

        if (employeePids.length === 0) {
          this.$message.error('选中的数据中没有有效的员工ID');
          return;
        }

        // 调用批量确认API
        const confirmData = {
          employeePids: employeePids,
          inspectionYearMonth: this.queryParams.yearMonth,
          confirmedBy: confirmedBy
        };

        confirmPerformance(confirmData).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('确认成功');
            this.selectedRows = [];
            this.getList();
          } else {
            this.$message.error((res && res.retMsg) || '确认失败');
          }
        }).catch(error => {
          console.error('确认失败:', error);
          this.$message.error('确认失败');
        });
      }).catch(() => {
        this.$message.info('已取消确认');
      });
    },

    /**
     * 详情按钮 - 打开详情弹窗
     * @param {Object} row - 当前行数据
     */
    handleDetail (row) {
      // 构建查询详情的参数
      // confirmationStatus: 0=未确认，1=已确认（需要转换为数字）
      // 使用行数据中的确认状态，而不是查询条件中的状态
      const isConfirmed = row.confirmationStatus === '1' || row.confirmationStatus === 1;
      const detailParams = {
        employeePid: row.employeePid,
        yearMonth: row.inspectionYearMonth || this.queryParams.yearMonth, // 优先使用行数据中的年月
        confirmationStatus: isConfirmed ? 1 : 0,
        performanceId: isConfirmed ? (row.performanceId || row.id || row.performancePid) : undefined
      };

      this.$refs.detailDialog.openDialog(detailParams, row);
    },

    /**
     * 表格选择变化
     * @param {Array} selection - 选中的行数据
     */
    handleSelectionChange (selection) {
      this.selectedRows = selection;
    },

    /**
     * 分页大小改变
     * @param {Number} val - 新的分页大小
     */
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页改变
     * @param {Number} val - 新的当前页
     */
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
